import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';

import { useSignUpForShareToPatient } from '../../../../shared/hooks/linkHook';
import {
  useSignInRedirect,
  useSignOut,
} from '../../../../shared/hooks/oauthHook';

export const ShareToPatientNonMember = () => {
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.shareToPatientNonMember',
  });
  const { mutate: signout } = useSignOut();
  const signInRedirect = useSignInRedirect();
  const { mutate: signup } = useSignUpForShareToPatient({
    onSuccess: async data => {
      await signout();
      signInRedirect({
        register: true,
        preset: data.presetId,
        redirect: '/images-list',
      });
    },
    onError: () => {
      // eslint-disable-next-line no-alert
      window.alert(`${t('linkExpired')}`);
      navigate('/');
    },
  });
  useEffect(() => {
    signup(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <></>;
};
